import http from 'shared/utils/http';

export const fetchCustomerType = () => {
  return http.get(`/netwila-core/customer/customer-type`);
};
